module.exports = __webpack_public_path__ + "static/media/coursesAndBatches.69fcd90c.svg";